export const USER_USECASE_ERROR_MESSAGES = {
  // Operation Errors
  CREATION_FAILED: 'Failed to create your profile. Please try again.',
  RETRIEVAL_FAILED: 'Unable to load your profile. Please try again.',
  UPDATE_FAILED: 'Failed to save your changes. Please try again.',
  DELETION_FAILED: 'Unable to delete your profile. Please try again.',

  // Authorization Errors
  UNAUTHORIZED: 'Your session has expired. Please sign in to continue.',
} as const;
